import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import {
  TheContent,
  TheSidebar,
  TheAside,
  TheFooter,
  TheHeader,
} from "./index";
import { useHistory } from "react-router";
import { useHotkeys } from "react-hotkeys-hook";
import { HOTKEYS } from "src/utils/utils";
import FloatingButton from "src/features/FloatingButton";

const TheLayout = () => {
  const darkMode = useSelector((state) => state.darkMode);
  const classes = classNames(
    "c-app c-default-layout",
    darkMode && "c-dark-theme"
  );

  const history = useHistory();
  useHotkeys(HOTKEYS.DASHBOARD, () => history.push("/dashboard"), {
    enableOnTags: ["INPUT", "SELECT", "TEXTAREA"],
  });
  useHotkeys(
    HOTKEYS.BOOKLET_RECEIVING,
    () => history.push("/booklet-receiving/add"),
    {
      enableOnTags: ["INPUT", "SELECT", "TEXTAREA"],
    }
  );
  useHotkeys(
    HOTKEYS.BOOKLET_ALLOCATION,
    () => history.push("/booklet-allocation"),
    {
      enableOnTags: ["INPUT", "SELECT", "TEXTAREA"],
    }
  );
  useHotkeys(
    HOTKEYS.TICKET_ENCODING,
    () => history.push("/ticket-encoding/add"),
    {
      enableOnTags: ["INPUT", "SELECT", "TEXTAREA"],
    }
  );
  useHotkeys(HOTKEYS.ASSESSMENT, () => history.push("/assessment/add"), {
    enableOnTags: ["INPUT", "SELECT", "TEXTAREA"],
  });
  useHotkeys(HOTKEYS.PAYMENT, () => history.push("/payment/add"), {
    enableOnTags: ["INPUT", "SELECT", "TEXTAREA"],
  });
  useHotkeys(HOTKEYS.AGENCY, () => history.push("/maintenance/agency"), {
    enableOnTags: ["INPUT", "SELECT", "TEXTAREA"],
  });
  useHotkeys(HOTKEYS.OFFICER, () => history.push("/maintenance/enforcer"), {
    enableOnTags: ["INPUT", "SELECT", "TEXTAREA"],
  });
  useHotkeys(HOTKEYS.SUPPLIER, () => history.push("/maintenance/supplier"), {
    enableOnTags: ["INPUT", "SELECT", "TEXTAREA"],
  });
  useHotkeys(
    HOTKEYS.VIOLATION,
    () => history.push("/maintenance/violation/add"),
    {
      enableOnTags: ["INPUT", "SELECT", "TEXTAREA"],
    }
  );
  return (
    <>
      <div className={classes}>
        <TheSidebar />
        <TheAside />
        <div className="c-wrapper">
          <TheHeader />
          <div className="c-body">
            <TheContent />
          </div>
          <TheFooter />
        </div>
      </div>
    </>
  );
};

export default TheLayout;
